import styled from 'styled-components'
import { COLOR } from 'src/service/constant/color'
import { customMedia } from 'src/styles/common/common'

const Main3SectionWrap = styled.div`
  padding-bottom: 34px;
  background: ${COLOR.gray10};
  display: flex;
`

const Main3SectionContent = styled.section`
  width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  ${customMedia.lessThan('tablet')`
     width: 328px;
     display: block;
     margin: 0 auto;
     >h4{   
       text-align: center;
       margin: 47px auto; 42px auto;
       font-family: NanumSquareNeoExtraBold, san-serif;
       font-size: 24px;
       line-height: 27px;
     }
`}
`
const Main3ContentLeft = styled.div`
  display: block;
  position: sticky;
  width: 430px;
  height: 500px;
  padding-top: 220px;
  margin-bottom: 400px;
  top: 76px;

  > .button_toggle {
    display: grid;
    grid-template-columns: repeat(2, 2fr);
    gap: 10px;
    width: 100%;
    
  }

  > p {
    font-family: NanumSquareNeoExtraBold, sans-serif;
    font-size: 60px;
    line-height: 66px;
    margin: 0 auto 66px auto;
  }
  ${customMedia.lessThan('tablet')`
     display: none;
`}
`
const Main3LeftBtn = styled.button`
  border-radius: 33.5px;
  border: none;
  font-size: 18px;
  font-family: NotoSansBold, sans-serif;
  line-height: 26px;
  width: 100%;
  height: 50px;
  background-color: ${(props) => props.color === 'active' ? COLOR.point1 : COLOR.gray20};
  color: ${(props) => props.color === 'active' ? COLOR.white : COLOR.blueGray5};
  padding: 0;
    //${(props) => props.color === COLOR.point1 ? COLOR.point1 : 'none'};
  ${customMedia.lessThan('tablet')`
     display: none;
`}
`

const Main3ContentRight = styled.div`
  width: 564px;
  position: sticky;
  padding-top: 220px;
  display: block;
  top: 76px;

  .gray-text {
    color: #7A828F;
  }

  > section {
    border-radius: 64px;
    display: block;
    width: 100%;
    margin: 0 0 200px 0;
    box-shadow: 0 1px 30px rgba(0, 0, 0, 0.08);

    > img {
      display: inline-block;
      width: 100%;
      height: 313px;
    }

    > div {
      padding: 24px 38px 32px 38px;
      display: block;

      > p {
        font-family: NanumSquareNeoExtraBold, sans-serif;
        font-size: 24px;
        line-height: 27px;
        margin: 0 0 12px 0;
      }

      > pre {
        font-family: NotoSansRegular, sans-serif;
        font-size: 16px;
        line-height: normal;
        white-space: normal;
        margin: 0;
      }
    }
  }
  ${customMedia.lessThan('tablet')`
    width: 100%;
    position: static;
    padding: 0;
    
    >section{
       border-radius: 24px;
       margin: 0 0 16px 0;
       >img{
          border-radius: 24px 24px 0 0 ;
          height:200px;
       }
       >div{
          padding: 20px 16px;
        >p{
          font-size: 18px;
          line-height: 20px;
          margin-bottom: 6px;
        }
        
      > pre {
        font-family: NotoSansRegular, sans-serif;
        font-size: 12px;
        line-height: normal;
        white-space: normal;
        margin: 0;
        
      }
     }
   }
`}
`
export {
  Main3SectionWrap,
  Main3SectionContent,
  Main3ContentLeft,
  Main3ContentRight,
  Main3LeftBtn
}
